import React from 'react';

import {NewTabLink} from 'fn-common-ui';
import config from 'config';

export default class Footer extends React.Component {

  renderBottomNav() {
    const externalLinks = {
      termsOfUse: 'https://www.firstnet.com/terms-and-conditions.html',
      accessibilityLink: 'https://www.firstnet.com/accessibility.html',
      privacyPolicyLink: 'https://www.firstnet.com/privacy-policy.html',
      firstnetGov: 'https://www.firstnet.gov'
    }
    return (<nav>
      <ul className="sub-links">
        <li role="presentation">
          <NewTabLink to={externalLinks.privacyPolicyLink}>
            Privacy Policy
          </NewTabLink>
        </li>
        <li role="presentation">
          <NewTabLink to={externalLinks.termsOfUse}>
          Terms and Conditions
          </NewTabLink>
        </li>
        <li className="xs-line-break"></li>
        <li role="presentation">
          <NewTabLink to={externalLinks.accessibilityLink}>
            Accessibility
          </NewTabLink>
        </li>
        <li role="presentation">
          <NewTabLink to={externalLinks.firstnetGov}>
            FirstNet.gov
          </NewTabLink>
        </li>
        <li className="xs-line-break"></li>
        <li role="presentation">
          <NewTabLink to={config.firstNetDoNotSell} className='privacy-choices'>
            Your Privacy Choices
          </NewTabLink>
          <img src="./images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon" style={{width: '1.5em'}}/>
        </li>
      </ul>
    </nav>);
  }

  render() {
    return (<div className="footer-container">
      <footer id="pse-footer">
        <div className="footer-main">
          <div className="container">
            <div className="row">
              <div className="col-12 logoRow">
                <img src="/images/firstnet-logo-white.svg" alt="FirstNet Training Portal logo" />
              </div>
            </div>
          </div>
        </div>
        <div className="footer-sub">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {this.renderBottomNav()}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>)
  }
}
